exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-voucher-page[data-v-7405779c]{padding:65px 0 30px;box-sizing:border-box}.app-voucher-page .form-content[data-v-7405779c]{width:520px;margin-left:180px}.app-voucher-page .form-content .opt-btn[data-v-7405779c]{display:inline-block;width:40px;height:16px;line-height:14px;font-size:12px;color:#f16222;text-align:center;border-radius:10px;margin-left:7px;border:1px solid #f16222;cursor:pointer;transform:scale(.9);transform-origin:top;position:relative;top:-1px}.app-voucher-page .title[data-v-7405779c]{font-size:16px;margin-bottom:20px;font-weight:700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7405779c","scoped":true,"hasInlineConfig":false}!./node_modules/postcss-loader/lib!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/control/app/voucher.vue
// module id = 868
// module chunks = 0